import {Box, styled} from '@mui/material';

const StyledBox = styled(Box)`
	background-color: ${({theme}) => theme.palette.background.paper};
	border-radius: 8px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px;
	height: 68px;
	cursor: pointer;
`;

export {StyledBox};
